import { Grid } from '@interstate/components/Grid';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import styled from 'styled-components';

interface DealSummaryContainer {
    $isCompactView?: boolean;
}

// Styled Components ignores props prefixed with $ when rendering the DOM. Prevents unnecessary attributes from appearing in the HTML output.
export const DealSummaryContainer = styled(Grid)<DealSummaryContainer>`
    ${({ $isCompactView }) => {
        if ($isCompactView) {
            return `
                .ids-list-items-container > div {
                    margin-bottom: 0px !important;
                    &:last-child > div {
                        border-bottom: none !important; /* Remove border for last item */
                    }
                }
                div.ids-list-item-content {
                    border-style: none;
                    border-bottom: 1px solid #b2b2b2 !important;
                    background-color: transparent;
                    padding: 0 0 0 8px;
                }
                /* Remove border and styling for empty content blocks */
                div.ids-list-item-content:empty {
                    display: none !important;
                }
                /* Also hide the parent list item if it only contains empty divs */
                .ids-list-group-item:empty {
                    display: none !important;
                }
                /* Hide list items with no visible content */
                .ids-list-group-item > div:empty {
                    display: none !important;
                }
                background-color: transparent;
                padding: 1rem 0.5rem !important;
                border-radius: 5px;
            `;
        }
        return `
            div.ids-item-content {
                padding: 0;
            }

            div.ids-list-item-content {
                padding: 0;
            }

            .empty-item > div.ids-item-content {
                background-color: #efefef;
            }

            @media (min-width: ${BreakPoint.TABLET_PORTRAIT}) {
                margin-bottom: 16px;
            }
        `;
    }}
`;
